import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import ExistingTriggersOptModal from 'automation-ui-enrollment/components/eventEnrollment/ExistingTriggersOptModal';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TriggerTypeChangeButton = ({
  flowId,
  hasExistingFilters,
  resetFilters,
  triggerType,
  readOnly
}) => {
  const [showExistingTriggersWarningModal, setShowExistingTriggersWarningModal] = useState(false);
  const selectionPagePath = `/platform/flow/${flowId}/edit/triggers`;
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const handleViewChange = triggerTypeBeforeChange => {
    trackEvent(Trackables.CLICKED_CHANGE_TRIGGER_TYPE_BUTTON, {
      enrollmentType: triggerTypeBeforeChange
    });
    if (hasExistingFilters) {
      setShowExistingTriggersWarningModal(true);
    } else {
      history.replace({
        pathname: selectionPagePath
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showExistingTriggersWarningModal && /*#__PURE__*/_jsx(ExistingTriggersOptModal, {
      view: "SELECTABLE_ENROLLMENT",
      onConfirm: () => {
        setShowExistingTriggersWarningModal(false);
        resetFilters(() => history.replace({
          pathname: selectionPagePath
        }));
      },
      onReject: () => setShowExistingTriggersWarningModal(false)
    }), !readOnly && /*#__PURE__*/_jsx(UIBackButton, {
      className: "m-y-3",
      children: /*#__PURE__*/_jsx(UILink, {
        "data-test-id": "trigger-selection-change-trigger-button",
        onClick: () => handleViewChange(triggerType),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollSelection.changeTrigger.buttonV2"
        })
      })
    })]
  });
};
export default TriggerTypeChangeButton;